import React from "react";

import Input from "../../components/Form/Input";
import Dropdown from "../../components/Form/Dropdown";
import CustomButton from "../../components/Buttons/CustomButton";

const CreateUnlimitedCoupon = ({
  couponCode,
  couponCodeErrorMessage,
  handleCouponCodeChange,
  handleCouponCodeBlur,
  discountType,
  discountTypeErrorMessage,
  handleDiscountTypeChange,
  handleDiscountTypeBlur,
  discountAmount,
  discountAmountErrorMessage,
  handleDiscountAmountChange,
  handleDiscountAmountBlur,
  planType,
  planTypeErrorMessage,
  handlePlanTypeChange,
  handlePlanTypeBlur,
  influencerName,
  influencerErrorMessage,
  handleInfluencerChange,
  handleInfluencerBlur,
  discountOptions,
  planOptions,
  handleSubmit,
  isValidForm,
  isCreatingCoupon,
  isFixedAmount = false,
}) => {
  return (
    <>
      <div className="flex flex-col gap-4">
        <div className="flex gap-5 h-[70px] items-end">
          <div className="flex-1">
            <Input
              label="Coupon Code"
              isRequired
              placeholder="Enter Coupon Code"
              value={couponCode}
              onChange={handleCouponCodeChange}
              onBlur={handleCouponCodeBlur}
              errorMessage={couponCodeErrorMessage}
              inputStyle="bg-[#45444433] border-[1px] border-[#808080] w-full min-w-[289px] h-[45px] uppercase"
              outerContainerStyle="mt-[-1px]"
              labelStyle="font-['Public_Sans'] font-normal text-[14px] leading-[22px] flex items-center text-[#E3E3E3] whitespace-nowrap"
              placeholderStyle="placeholder:text-[#808080] placeholder:text-[14px] placeholder:font-['Public_Sans'] placeholder:font-normal placeholder:normal-case"
            />
          </div>

          <div className="flex-1">
            {isFixedAmount ? (
              <Input
                label="Discount Amount ($)"
                isRequired
                placeholder="Enter Amount (e.g., 10.00)"
                type="number"
                step="0.01"
                min="0"
                value={discountAmount}
                onChange={handleDiscountAmountChange}
                onBlur={handleDiscountAmountBlur}
                errorMessage={discountAmountErrorMessage}
                inputStyle="bg-[#45444433] border-[1px] border-[#808080] w-full min-w-[289px] h-[45px]"
                outerContainerStyle="mt-[-1px]"
                labelStyle="font-['Public_Sans'] font-normal text-[14px] leading-[22px] flex items-center text-[#E3E3E3] whitespace-nowrap"
                placeholderStyle="placeholder:text-[#808080] placeholder:text-[14px] placeholder:font-['Public_Sans'] placeholder:font-normal"
              />
            ) : (
              <Dropdown
                key={`discount-${discountType}`}
                label="Discount Type"
                options={discountOptions}
                placeholder="Select Discount"
                displayKey="name"
                idKey="name"
                isRequired
                wrapperClassName="text-[#E2E2E2] text-[15px] font-[300] font-['Public Sans'] w-full min-w-[281px]"
                dropdownClassName="bg-[#2D2D2D] border-[#808080] border z-20"
                optionClassName="text-[#E2E2E2] py-2"
                buttonClassName="h-[45px]"
                filterClassName="border-t border-[#505050]"
                labelStyle="font-['Public_Sans'] font-normal text-[14px] leading-[22px] flex items-center text-[#E3E3E3] whitespace-nowrap"
                placeholderClassName="text-[#808080] text-[14px] font-['Public Sans'] font-normal"
                isSearchable
                allowClear={false}
                defaultOption={discountType ? { name: discountType } : undefined}
                errorMessage={discountTypeErrorMessage}
                onSelect={(option) =>
                  handleDiscountTypeChange({
                    target: {
                      type: "select-one",
                      value: option?.name ?? "",
                      options: [{ id: option?._id }],
                      selectedIndex: 0,
                    },
                  })
                }
                onBlur={handleDiscountTypeBlur}
              />
            )}
          </div>
        </div>

        <div className="flex gap-5 h-[70px] items-end mt-2">
          <div className="flex-1">
            <Dropdown
              key={`plan-${planType}`}
              label="Plan Type"
              options={planOptions}
              placeholder="Select Plan"
              displayKey="name"
              idKey="name"
              isRequired
              wrapperClassName="text-[#E2E2E2] text-[15px] font-[300] font-['Public Sans'] w-full min-w-[281px]"
              dropdownClassName="bg-[#2D2D2D] border-[#808080] border z-20"
              optionClassName="text-[#E2E2E2] py-2"
              buttonClassName="h-[45px]"
              filterClassName="border-t border-[#505050]"
              labelStyle="font-['Public_Sans'] font-normal text-[14px] leading-[22px] flex items-center text-[#E3E3E3] whitespace-nowrap"
              placeholderClassName="text-[#808080] text-[14px] font-['Public Sans'] font-normal"
              isSearchable
              allowClear={false}
              defaultOption={planType ? { name: planType } : undefined}
              errorMessage={planTypeErrorMessage}
              onSelect={(option) =>
                handlePlanTypeChange({
                  target: {
                    type: "select-one",
                    value: option?.name ?? "",
                    options: [{ id: option?._id }],
                    selectedIndex: 0,
                  },
                })
              }
              onBlur={handlePlanTypeBlur}
            />
          </div>

          <div className="flex-1">
            <Input
              label="Influencer"
              placeholder="Enter Influencer Name"
              isRequired={true}
              value={influencerName}
              onChange={handleInfluencerChange}
              onBlur={handleInfluencerBlur}
              errorMessage={influencerErrorMessage}
              inputStyle="bg-[#45444433] border-[1px] border-[#808080] w-full min-w-[289px] h-[45px]"
              outerContainerStyle="mt-[-1px]"
              labelStyle="font-['Public_Sans'] font-normal text-[14px] leading-[22px] flex items-center text-[#E3E3E3] whitespace-nowrap"
              placeholderStyle="placeholder:text-[#808080] placeholder:text-[14px] placeholder:font-['Public_Sans'] placeholder:font-normal placeholder:normal-case"
            />
          </div>
        </div>
      </div>

      <div className="mt-6 flex justify-end">
        <CustomButton
          useGradientBorder
          rounded="rounded-lg"
          textSize="text-[18px] leading-[24px]"
          padding="py-[10.5px] px-[13.5px]"
          font="font-public-sans"
          border="border-lg"
          type="button"
          width="w-[149px]"
          onClick={handleSubmit}
          disabled={!isValidForm || isCreatingCoupon}
          loading={isCreatingCoupon}
        >
          {isCreatingCoupon ? "Creating..." : "Create Coupon"}
        </CustomButton>
      </div>
    </>
  );
};

export default CreateUnlimitedCoupon;
